// Возвращает случайное целое число между min (включительно) и max (не включая max)
export function getRandomInt(min: number, max: number) {
  if (min > max) {
    return null;
  }

  return Math.floor(Math.random() * (max - min)) + min;
}
